import { useMemo } from 'react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'
import { useQuery } from '@apollo/client'
import { Trans, useLingui } from '@lingui/react/macro'
import { UserGroup03Icon } from '@hugeicons/core-solid-rounded'

import * as Table from '@/components/ui/Table'
import Loading from '@/components/ui/Loading'

function LoadingRow() {
  return (
    <Table.Row className="pointer-events-none">
      <Table.Cell colSpan={6}>
        <div className="flex flex-row justify-center p-4">
          <Loading />
        </div>
      </Table.Cell>
    </Table.Row>
  )
}

function GuestRow({ id }: { id: number }) {
  const { data } = useQuery(AdminAPI.guest.GET, {
    variables: { id }
  })

  const guest = useMemo(
    () => getFragment(SharedAPI.guest.GUEST_FRAGMENT, data?.getGuest),
    [data]
  )

  if (!guest) return null

  return (
    <Table.Row>
      <Table.Cell>{guest.title}</Table.Cell>
      <Table.Cell>
        {guest.firstName} {guest.lastName}
      </Table.Cell>
      <Table.Cell>{guest.email}</Table.Cell>
    </Table.Row>
  )
}

interface Props {
  ids: number[]
  loading?: boolean
}

export default function GuestTable(props: Props) {
  const { ids, loading = false } = props

  const { t } = useLingui()

  return (
    <Table.Root>
      <Table.Head>
        <Table.Row>
          <Table.Heading>
            <Trans>Personal Title</Trans>
          </Table.Heading>
          <Table.Heading>
            <Trans>Name</Trans>
          </Table.Heading>
          <Table.Heading>
            <Trans>Email</Trans>
          </Table.Heading>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {ids.map(id => (
          <GuestRow key={id} id={id} />
        ))}
        {loading && <LoadingRow />}
        {!loading && ids.length === 0 && (
          <Table.Empty text={t`Not Guests found`} Icon={UserGroup03Icon} />
        )}
      </Table.Body>
    </Table.Root>
  )
}
